import "../../../../auw_gallery/Resources/Private/Js/main.js";
import "../../../../auw_mobile_push_menu/Resources/Private/Js/main.js";
// AST, 13.03.2025: Transfer des JS nach BD Core
// import "../../../../auw_solr/Resources/Private/Js/main.js";
import "./../../../../bdcore/Resources/Private/_Js/AuwSearch.js";
import "../../../../auw_video/Resources/Private/Js/main.js";
import "../../../../auw_container/Resources/Private/Js/main.js";
import "../../../../auw_custom_content/Resources/Private/Js/main.js";
